import React, { useContext } from "react";
import sld from "../../images/sld/Rectangle.svg";

import Linebar from "../../components/GRIDCONNECTED/Linebar";
import embLabels from "../../config/emb-labels-en.json";

import { DesignAssetContext } from "../CustomHooks/ContextApi"; 
import { uniqueId } from "lodash";
import Ecc from "../../components/ETOIslandable/Ecc";
import Busbar from "../../components/ETOIslandable/Busbar";

import Genset from "../../components/ETOIslandable/Genset";
import Battery from "../../components/ETOIslandable/Battery";
import PV1 from "../../components/ETOIslandable/PV1";
import PV2 from "../../components/ETOIslandable/PV2";
import PV3 from "../../components/ETOIslandable/PV3";
// import CHP from "../../components/ETOIslandable/CHP";
import Load from "../../components/ETOIslandable/Load"
import Ev from "../../components/ETOIslandable/Ev";
import Utility from "../../components/ETOIslandable/Utility";
import LoadPvBess from "../../components/GensetPvBess/LoadPvBess";
const IslandableEtoSLD = () => {
  const {
    CBAssetList = [],
    CBEVList = [],
    CBLoadList = [],
    sldLoadCompleted,
    projectKind,
    switchboardType,
    coordinates,
    count,
    loadSide,
  } = useContext(DesignAssetContext);
  const areAllConfigured = () =>{
    return CBLoadList?.every(item => item.uiData.configured);
  }
  const getLoadXPosition = ()=>{
    if(switchboardType === embLabels?.EXISTING_SWITCHBOARD){
     return count?.derCount === 6
     ?count?.evCount === 1?loadSide ==="LOAD_SIDE"?40:150:130
     :count?.derCount === 5
     ? count?.evCount === 1?loadSide ==="LOAD_SIDE"?90:150:100
     :count?.derCount === 4
     ?count?.evCount === 1 ?loadSide ==="LOAD_SIDE"?130:180:120
     :count?.derCount === 3
     ?count?.evCount=== 1?loadSide ==="LOAD_SIDE"?100:150:100:0 
    }else{
      return count?.derCount === 5
      ? -30
      :count?.derCount === 4
      ?-20
      :count?.derCount === 3
      ?10:count?.evCount === 1?-80:0
    }
   
    
  }
  const getEvXPosition = ()=>{
    if(switchboardType === embLabels?.EXISTING_SWITCHBOARD){
      return  count?.derCount === 6
      ?  50
      : count?.derCount === 5
      ?  80
      : count?.derCount === 4
      ? 70
      : count?.derCount === 3
      ? 40
      : 0
    }else{
      return  count?.derCount === 6
      ?  50
      : count?.derCount === 5
      ? 80
      : count?.derCount === 4
      ? 70
      : count?.derCount === 3
      ? 30
      : 0
    }
   
  }
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
      <svg viewBox="0 0 1300 800">
        <g>
          <svg x="0" y="0" viewBox="0 0 1300 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>
            <svg x={switchboardType === embLabels?.EXISTING_SWITCHBOARD?0:count?.derCount === 6 ?-80:count?.derCount === 5?-60:""}>
            <g
              id="components-sld"
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
               <Ecc/>
              <svg x={switchboardType === "NEW_SWITCHBOARD"?"-20":""}>
              <svg x={switchboardType === "NEW_SWITCHBOARD"?"30":""}>
              <Busbar secondBusbar={true} />
              {(projectKind?.isMGaaSETOIsland) &&
                switchboardType === embLabels?.EXISTING_SWITCHBOARD && (
                  <Linebar key={uniqueId()} />
                )}
                </svg>
              <Utility />
              {CBAssetList?.[1].uiData.status && <Genset />}
              {CBAssetList?.[2].uiData.status && <Battery />}
              {CBAssetList?.[3].uiData.status && <PV1 />}
              {CBAssetList?.[4].uiData.status && <PV2 />}
              {CBAssetList?.[5].uiData.status && <PV3 />}
              {/* {CBAssetList[6].uiData.status && <CHP />} */}
              <svg
                id="load pointer1"
                x={getLoadXPosition()}
                y="0"
              >
                {/* {CBLoadList?.map((loadData, key) => (
                  <Load 
                    key={loadData.uiData.xAxis}
                    load={loadData.uiData}
                    loadName={loadData.configData.name}
                    loadCbName={loadData.cbConfigData.name}
                    index={key}
                    powerMeterData={loadData.powerMeterData}
                  />
                ))} */}
                 {CBLoadList.length > 0 &&
                              <LoadPvBess
                              loadLength = {count}
                                configured = {areAllConfigured()}
                                isEVThere = {CBEVList?.[0].uiData.status}
                              />
                            }
              </svg>
              <svg
                x={getEvXPosition() }
                y="0"
              >
              {CBEVList?.map(
                (cbData, key) =>
                  cbData.uiData.status && (
                    <Ev key={cbData.configData.name} index={key} />
                  )
              )}
              </svg>
              </svg>
            </g>
            </svg>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default IslandableEtoSLD;
